import { CSSProperties, useMemo } from 'react'
import TreeGroupDropdown from '@/shared/Tree/components/TreeGroupDropdown'
import { ITreeGroup } from '@/shared/Tree/tree.types.ts'
import { ILibraryGroup } from '@/pages/Library/libraryGroups.types.ts'
import useLibraryGroups from '@/pages/Library/hooks/useLibraryGroups.ts'

interface IProps {
  value: ILibraryGroup['id']
  name: string
  onChange: (val: ILibraryGroup['id'], name: string) => void
  title?: string
  wrapperStyle?: CSSProperties
}

const LibraryGroupDropdown = (props: IProps) => {
  const groups = useLibraryGroups().libraryGroupsState.items

  const treeGroups: ITreeGroup<ILibraryGroup, number>[] = useMemo(() => {
    if (!groups.length) return []

    return groups.map((g) => ({ id: g.id, parentId: g.parentId, data: g, type: 'none' }))
  }, [groups])

  return (
    <TreeGroupDropdown
      name={props.name}
      wrapperStyle={props.wrapperStyle}
      optionNameGetter={(group: ILibraryGroup) => group.name}
      title={props.title || 'Выберите группу'}
      options={treeGroups as any}
      onSelect={props.onChange}
      selectedOption={props.value as any}
    />
  )
}

export default LibraryGroupDropdown
